import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { v_DispatchAttachmentBus } from './v_DispatchAttachmentBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { DispatchRefTrackingBus } from './DispatchRefTrackingBus';

export class AdditionalCnstJobData extends BaseBus
{
    constructor(data: AdditionalCnstJobData = null) {
        super(data);
        if (CommonFunctions.hasValue(data)) {
            this.contractNumber = data.contractNumber;
            this.isMainJob = data.isMainJob;
            this.contractPONumber = data.contractPONumber;
            let arrRefTrk = [];
            if (CommonFunctions.hasArrayValue(data.refTracking)) {
                for (let i = 0; i < data.refTracking.length; i++) {
                    let refTrkData = new DispatchRefTrackingBus(data.refTracking[i]);
                    arrRefTrk.push(refTrkData);
                }
                this.refTracking = arrRefTrk;
            }
        }
    }
    clear() {
        this.contractNumber = "";
        this.contractPONumber = "";
        this.isMainJob = false;
        this.refTracking = null;
    }
    contractNumber: string;
    contractPONumber: string;
    isMainJob: boolean;
    quoteEstimator: string;
    refTracking: DispatchRefTrackingBus[];

}
